(function () {
  if (window.SolvraHeroSlider) return;

  class SolvraHeroSlider {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
      this.dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
      this.prevButton = root.querySelector('[data-hero-prev]');
      this.nextButton = root.querySelector('[data-hero-next]');
      this.viewport = root.querySelector('[data-hero-viewport]');
      this.index = 0;
      this.touchStartX = 0;
      this.hoverPaused = false;
      this.autoplayPausedUntil = 0;
      this.autoplayTimer = null;
      this.autoplayEnabled = root.dataset.autoplay === 'true';
      this.autoplayInterval = (parseInt(root.dataset.autoplayInterval, 10) || 4) * 1000;
      this.onMouseEnter = () => {
        this.hoverPaused = true;
      };
      this.onMouseLeave = () => {
        this.hoverPaused = false;
      };

      if (this.slides.length === 0) return;

      this.prevButton?.addEventListener('click', () => this.prev());
      this.nextButton?.addEventListener('click', () => this.next());
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const target = parseInt(dot.dataset.heroDot, 10);
          if (!Number.isNaN(target)) this.goTo(target);
        });
      });

      this.viewport?.addEventListener('touchstart', (event) => {
        this.touchStartX = event.touches[0].clientX;
      }, { passive: true });

      this.viewport?.addEventListener('touchend', (event) => {
        const delta = this.touchStartX - event.changedTouches[0].clientX;
        if (Math.abs(delta) < 40) return;
        this.pauseAutoplayTemporarily(5000);
        if (delta > 0) this.next();
        else this.prev();
      }, { passive: true });

      this.root.addEventListener('mouseenter', this.onMouseEnter);
      this.root.addEventListener('mouseleave', this.onMouseLeave);

      this.goTo(0, true);
      this.startAutoplay();
    }

    destroy() {
      this.stopAutoplay();
      this.root.removeEventListener('mouseenter', this.onMouseEnter);
      this.root.removeEventListener('mouseleave', this.onMouseLeave);
      delete this.root._solvraHeroSlider;
      this.root.dataset.heroSliderReady = 'false';
    }

    pauseAutoplayTemporarily(duration) {
      this.autoplayPausedUntil = Date.now() + duration;
    }

    startAutoplay() {
      this.stopAutoplay();
      if (!this.autoplayEnabled || this.slides.length <= 1) return;

      this.autoplayTimer = window.setInterval(() => {
        if (this.hoverPaused) return;
        if (Date.now() < this.autoplayPausedUntil) return;
        this.next(true);
      }, this.autoplayInterval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    goTo(index, silent) {
      if (this.slides.length === 0) return;
      this.index = ((index % this.slides.length) + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === this.index);
        slide.setAttribute('aria-hidden', slideIndex === this.index ? 'false' : 'true');
      });

      this.dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === this.index);
        dot.setAttribute('aria-current', dotIndex === this.index ? 'true' : 'false');
      });

      if (!silent) {
        this.pauseAutoplayTemporarily(5000);
      }
    }

    next(fromAutoplay) {
      this.goTo(this.index + 1, !!fromAutoplay);
    }

    prev() {
      this.goTo(this.index - 1, false);
    }
  }

  window.SolvraHeroSlider = SolvraHeroSlider;

  window.initSolvraHeroSlider = function (root) {
    if (!root) return null;
    if (root._solvraHeroSlider) {
      root._solvraHeroSlider.destroy();
    }
    root.dataset.heroSliderReady = 'true';
    root._solvraHeroSlider = new SolvraHeroSlider(root);
    return root._solvraHeroSlider;
  };

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-solvra-hero-slider]').forEach((root) => {
      window.initSolvraHeroSlider(root);
    });
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-solvra-hero-slider]').forEach((root) => {
      root._solvraHeroSlider?.destroy();
    });
  });
})();
